module.exports = __webpack_public_path__ + "media/site_templates/www.wall-repair.com.au/images/testimonials-7fad60003ae74afd7997fdb5a774ac9e.jpg";